import { ButtonGroup, Menu, MenuItem } from "@blueprintjs/core";
import { Popover2 } from "@blueprintjs/popover2";
import React from "react";

import { Pagination } from "../../../hooks/use-pagination";
import { Button } from "../../Button/button";
import styles from "./table-footer.module.scss";

export interface TableFooterProps extends Pagination {
  totalRows: number;
}

export const TableFooter = ({
  page,
  pageSize,
  totalRows,
  setPageSize,
  incrementPage,
  decrementPage,
  resetPage,
}: TableFooterProps) => {
  return (
    <div className={styles.tableFooter}>
      <Popover2
        content={
          <Menu>
            <MenuItem text="10 per view" onClick={() => setPageSize(10)} />
            <MenuItem text="20 per view" onClick={() => setPageSize(20)} />
            <MenuItem text="40 per view" onClick={() => setPageSize(40)} />
            <MenuItem text="100 per view" onClick={() => setPageSize(100)} />
          </Menu>
        }
        minimal
        placement="top"
      >
        <span className={styles.pageRange}>
          {pageSize * page + 1} - {Math.min(totalRows, pageSize * page + pageSize)}
        </span>
      </Popover2>
      of {totalRows}
      <ButtonGroup className={styles.footerButtonGroup}>
        <Button icon="double-chevron-left" minimal onClick={resetPage} disabled={page === 0} />
        <Button icon="chevron-left" minimal onClick={decrementPage} disabled={page === 0} />
        <Button
          icon="chevron-right"
          minimal
          onClick={incrementPage}
          disabled={pageSize * page + pageSize >= totalRows}
        />
      </ButtonGroup>
    </div>
  );
};
